export const ALL_REDIRECTS_KEY = 'boostPFSAllRedirects';
